export const getPersonId = (attendee) => attendee.tempId || attendee.id;

export const buildPeopleList = (values) => {
  const people = [{
    id: values.id,
    orderIndex: -1,
    forename: values.forename,
    name: values.name,
    companionOf: values.customAttributes?.companionOf || '',
    showInProgram: values.customAttributes?.showInProgram,
    fieldPath: 'customAttributes.companionOf',
    showInProgramFieldPath: 'customAttributes.showInProgram',
  }];
  (values.attendees || []).forEach((attendee, index) => {
    people.push({
      id: getPersonId(attendee),
      orderIndex: index,
      forename: attendee.forename,
      name: attendee.name,
      companionOf: attendee.customAttributes?.companionOf || '',
      showInProgram: attendee.customAttributes?.showInProgram,
      fieldPath: `attendees.${index}.customAttributes.companionOf`,
      showInProgramFieldPath: `attendees.${index}.customAttributes.showInProgram`,
    });
  });
  return people;
};

export const getPersonLabel = (person) => {
  if (!person) return '';
  const full = `${person.forename || ''} ${person.name || ''}`.trim();
  return full || '(noch kein Name)';
};

// Sets (or clears, when partnerId is falsy) a bidirectional companion link between two
// people, automatically dissolving any previous link either side may have had.
export const setLink = (form, people, personId, partnerId) => {
  const person = people.find((p) => p.id === personId);
  if (!person) return;

  if (person.companionOf && person.companionOf !== partnerId) {
    const oldPartner = people.find((p) => p.id === person.companionOf);
    if (oldPartner) form.change(oldPartner.fieldPath, '');
  }

  if (!partnerId) {
    form.change(person.fieldPath, '');
    return;
  }

  const newPartner = people.find((p) => p.id === partnerId);
  if (newPartner?.companionOf && newPartner.companionOf !== personId) {
    const otherPerson = people.find((p) => p.id === newPartner.companionOf);
    if (otherPerson) form.change(otherPerson.fieldPath, '');
  }

  form.change(person.fieldPath, partnerId);
  if (newPartner) form.change(newPartner.fieldPath, personId);
};

export const unlink = (form, people, personId) => setLink(form, people, personId, null);

// A tempId only survives until the attendee is first saved by the backend, so a
// companionOf value pointing at a not-yet-saved attendee cannot be sent as-is —
// it's translated into an index into the submitted attendees array instead
// (same idea as the existing companionTempId -> companionIndex mapping).
// The API uses zero-based attendee indexes.
export const encodeCompanionOfForSubmit = (companionOf, submittedAttendees, hostId) => {
  // Send null explicitly so the API removes an existing companion link.
  if (!companionOf) return null;
  if (hostId !== undefined && String(companionOf) === String(hostId)) return { id: hostId };
  const partnerIndex = submittedAttendees.findIndex(({ tempId, id }) => (tempId || id) === companionOf);
  if (partnerIndex === -1) return undefined;
  const partner = submittedAttendees[partnerIndex];
  if (partner.id) return { id: partner.id }; // already has a stable backend id
  return { index: partnerIndex };
};

// Reverses encodeCompanionOfForSubmit once the backend has assigned real ids,
// resolving an `{ index }` placeholder against the freshly loaded attendees array.
export const decodeCompanionOfAfterLoad = (companionOf, loadedAttendees) => {
  if (!companionOf) return '';
  if (typeof companionOf === 'string') return companionOf;
  if (companionOf.id) return companionOf.id;
  if (companionOf.index !== undefined) return loadedAttendees[companionOf.index]?.id || '';
  return '';
};
